import {Component, computed, inject} from '@angular/core';
import {ThemeService} from '@/app/core/services/theme/theme.service';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
  protected reportContent = computed(() => this.themeContent()?.reports);
  protected emptyStateComponent = computed(() => this.reportContent()?.emptyStateComponent)
  private themeService = inject(ThemeService);
  protected themeContent = this.themeService.themeContent;
}
